import { cn } from "../../../../utils/classnames";

/**
 * One titled block of the register card ("Account Information", ...).
 * A hairline separates it from the next block; the last block has none.
 */
const FormSection = ({ title, description, isRequired = true, isLast = false, children }) => (
  <section className={cn("tw:py-7 tw:first:pt-0", isLast ? "tw:pb-0" : "tw:border-b tw:border-[#EFEFEF]")}>
    <div className="tw:mb-5">
      <h5 className="tw:!m-0 tw:!text-[17px] tw:!font-bold tw:!text-[#282828]">
        {title}
        {isRequired && <span className="tw:ml-1 tw:text-[#dc3545]">*</span>}
      </h5>
      {description && (
        <div className="tw:mt-1 tw:text-[13px] tw:leading-relaxed tw:text-[#8D8D8D]">{description}</div>
      )}
    </div>
    {children}
  </section>
);

export default FormSection;
